export default "__VITE_ASSET__DuukwPJa__"